<template>
  <div>
      <div class="navtit">
          {{$t('home.nav4')}}
      </div>
      <div class="banner">
          <img src="../assets/5.jpg" alt="">
      </div>
      <div class="container">
          <el-row :gutter="50" style="width: 800px;margin:0 auto;">
              <el-col :span="6">
                  <div :class="['descript-item',index == '1' ? 'active' : '']" @click="getTabs('1')">
                  <div class="descript-item-top">{{$t('item5.tit1')}}</div>
                  </div>
              </el-col>
              <el-col :span="6">
                  <div :class="['descript-item',index == '2' ? 'active' : '']" @click="getTabs('2')">
                  <div class="descript-item-top">{{$t('item5.tit2')}}</div>
                  </div>
              </el-col>
              <el-col :span="6">
                  <div :class="['descript-item',index == '3' ? 'active' : '']" @click="getTabs('3')">
                  <div class="descript-item-top">{{$t('item5.tit3')}}</div>
                  </div>
              </el-col>
              <el-col :span="6">
                  <div :class="['descript-item',index == '4' ? 'active' : '']" @click="getTabs('4')">
                  <div class="descript-item-top">{{$t('item5.tit4')}}</div>
                  </div>
              </el-col>
          </el-row>
          <el-divider></el-divider>
          <div class="file-con" v-if="index == '1'">
              <img src="http://image.sinajs.cn/newchart/hk_stock/min/02520.gif" alt="">
          </div>
          <div class="file-con" v-if="index == '2'">
              <img src="http://image.sinajs.cn/newchart/hk_stock/daily/02520.gif" alt="">
          </div>
          <div class="file-con" v-if="index == '3'">
              <img src="http://image.sinajs.cn/newchart/hk_stock/weekly/02520.gif" alt="">
          </div>
          <div class="file-con" v-if="index == '4'">
              <img src="http://image.sinajs.cn/newchart/hk_stock/monthly/02520.gif" alt="">
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      index: '1'
    }
  },

  mounted () {

  },
  methods: {
    getTabs (e) {
      this.index = e
    }
  }
}
</script>
<style scoped>
.el-divider--horizontal{
  margin: 0;
}
.navtit{
font-size: 36px;
  color: #000000;
  line-height: 45px;
  text-align: center;
  padding: 30px 60px;
}
.banner{
width: 100%;
height: 540px;
margin: 0 auto;
overflow: hidden;
}
.banner img{
width: 100%;
height: 100%;
}
.container {
  width: 1050px;
  margin: 0 auto;
  padding: 80px 0;
}
.descript-item {
  background-color: #f7f7f7;
  width: 100%;
  height: 40px;
  /* border-radius: 5px; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  font-size: 18px;
  color: #409EFF;
  line-height: 45px;
}
.descript-item:hover{
  background-color: #409EFF;
  color: white;
}
.active{
  background-color: #409EFF;
  color: white;
}
.file-con{
  margin-top: 50px;
  text-align: center;
}
.file-con img{
  width: 77%;
  height: auto;
}
</style>
